
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { CartProvider } from "./context/CartContext";
import CartDrawer from "./components/feature/CartDrawer";
import CartButton from "./components/feature/CartButton";

function App() {
  return (
    <CartProvider>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
        <CartDrawer />
        <CartButton />
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
